import { Component } from 'react';

class Aboutus extends Component{
  render() {
    return (
    
        <div className='aboutus'>
          <h2>This page is currently under working...<br></br>
          This page is currently under working..This page is currently under working..This page is currently under working..
          <br></br>This page is currently under working..This page is currently under working..This page is currently under working..<br></br>
          This page is currently under working..This page is currently under working..This page is currently under working..This page is currently under working..</h2>

          {/* <button onClick={()=>window.open('https://www.youtube.com/','_self')}>
          <img src="bellR.png" width={50} height={50} />Youtube</button> */}

      </div>
    )
  }
}

export default Aboutus;